import { get } from '../../Services/http';
import { catchError } from '../Error.action';
import { VARIANTSFILTER_LOAD_ERROR, VARIANTSFILTER_RECIVE } from '../../Rutab/RutabConstants';

const url = '/api/variants/' + document.getElementById('variantFilter').dataset.baseproductsystemid;

export const loadVariants = () => (dispatch, getState) => {
    return (get(url)
        .then((response) => response.json())
        .then((data) => dispatch(receive(data)))
        .catch((ex) => dispatch(catchError(ex, (error) => loadError(error)))
        ));
};

export const loadError = (error) => ({
    type: VARIANTSFILTER_LOAD_ERROR,
    payload: {
        error,
    },
});

export const receive = (data) => ({
    type: VARIANTSFILTER_RECIVE,
    payload: {
        variants: data,
    },
});
